<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="14" y="24" width="72" height="52" stroke="black" stroke-width="4"/>
<path d="M16 35L85 35" stroke="black" stroke-width="4"/>
<path d="M16 25L85 25" stroke="black" stroke-width="4"/>
<path d="M26 29H22" stroke="black" stroke-width="4"/>
<path d="M26 32H22" stroke="black" stroke-width="4"/>
<path d="M86 29L32 29" stroke="black" stroke-width="4"/>
<path d="M86 32L32 32" stroke="black" stroke-width="4"/>
<path d="M16 36L84 36" stroke="black" stroke-width="4"/>
<path d="M23 50H52" stroke="black" stroke-width="4"/>
<path d="M23 63H75" stroke="black" stroke-width="4"/>
</svg>

</template>
